import DeletingItemsTable from '@/common/components/notification-center/DeletingItemsTable.vue';
import FilesLoadingTable from '@/common/components/notification-center/FilesLoadingTable.vue';
import i18n from '@/common/i18n';
import store from '@/common/store';
import useAbgwStore from '@/common/store/pinia/abgw';
import useGlobalDialog from '@/common/composables/useGlobalDialog';
import useS3FilesStore from '@/common/store/pinia/s3Files';
import useComputeImagesStore from '@/common/store/pinia/computeImages';
import createStore from '@/common/store/createStore';

const actionsMap = {
  abortImage: ({ globalConfirm }, { fileName, id }) => globalConfirm().create({
    title: i18n.t('Abort upload?'),
    content: i18n.t('Are you sure you want to abort the upload of "{name}"?', { name: fileName }),
    buttonCancel: i18n.t('Continue uploading'),
    buttonConfirm: i18n.t('Abort upload'),
    action: () => {
      const computeImagesStore = useComputeImagesStore();
      return computeImagesStore.abort(id);
    }
  }),
  openDeletingItemsDialog: (_ctx, { notificationId }) => {
    const globalDialog = useGlobalDialog();

    globalDialog.reveal({
      dialog: {
        title: i18n.t('Deleting items'),
      },
      component: {
        name: DeletingItemsTable,
        attrOrProp: {
          notificationId
        }
      },
      actions: [
        {
          slotName: 'footer',
          label: i18n.t('Close'),
          click: () => globalDialog.cancel()
        }
      ],
    });
  },
  openFileLoadingDialog: (_ctx, { notificationId }) => {
    const globalDialog = useGlobalDialog();
    const s3FilesStore = useS3FilesStore();

    globalDialog.reveal({
      dialog: {
        title: i18n.t('Uploading files'),
        widthSize: 'large',
      },
      component: {
        name: FilesLoadingTable,
      },
      actions: [
        {
          slotName: 'footer',
          label: i18n.t('Close'),
          click: () => globalDialog.cancel()
        },
        {
          slotName: 'footer-aside',
          label: i18n.t('Cancel all'),
          click: () => s3FilesStore.abortUploads(),
          type: 'secondary'
        }
      ],
    });
    store.dispatch('notifications/DISMISS', notificationId);
  },
  cancelUploads: () => {
    const s3FilesStore = useS3FilesStore();
    return s3FilesStore.abortUploads();
  },
  pauseUpdates: () => store.dispatch('updates/PAUSE'),
  cancelUpdates: () => store.dispatch('updates/CANCEL_UPDATES'),
  abgwRetryProgressProcess: (_ctx, payload) => {
    const abgwStore = useAbgwStore();
    return abgwStore.retryProgressProcess(payload);
  },
  abortServerMigration: ({ globalConfirm }, { serverId, requestId }) => {
    createStore(['servers']);

    const serverName = store.getters['servers/getItemById'](serverId)?.name;

    globalConfirm().create({
      title: i18n.t('Cancel migration'),
      content: i18n.t('Are you sure you want to cancel migration of the virtual machine "{name}"?', { name: serverName }),
      buttonCancel: i18n.t('Cancel'),
      buttonConfirm: i18n.t('Confirm'),
      action: () => store.dispatch('servers/ABORT_MIGRATION', { id: serverId, requestId })
    });
  }
};

export default actionsMap;
